import React, {Component} from "react";
import flipPhone_es from '../../Resources/girar_celular_esp.jpg'
import flipPhone_en from '../../Resources/girar_celular_eng.jpg'
import flipPhone_pt from '../../Resources/girar_celular_por.jpg'
import {injectIntl} from "react-intl";
import {LanguageContext} from "../../Utilities/LanguageContext";
import {gsap} from "gsap";

class MobilePopup extends Component<{ showPopup: any}> {
    static contextType = LanguageContext

    constructor(props, context) {
        super(props, context);

        this.mobileAnim = gsap.timeline({paused: true});
    }

    componentDidMount() {
        this.mobileAnim.to('#mobile-popup', {
            scale: 0,
            opacity: 0,
        });
    }

    render() {
        return <section id={"mobile-popup"}>
            <div className={"popup-fullscreen"}>
                <div className={"mobile-popup"}>
                    <img src={this.context.i18nConfig.locale === "pt" ? flipPhone_pt :
                        this.context.i18nConfig.locale === "en" ? flipPhone_en :
                            flipPhone_es}/>
                </div>
            </div>
        </section>;
    }
}

export default injectIntl(MobilePopup)
